export default "/_next/static/images/1e6924071e49940fc42c3a0f81653cf6.jpg";